function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List, Map } from 'immutable';
import { Fullscreen } from 'decap-cms-ui-next';
import RawEditor from './RawEditor';
import VisualEditor from './VisualEditor';
import { jsx as ___EmotionJSX } from "@emotion/react";
const MODE_STORAGE_KEY = 'cms.md-mode';

// TODO: passing the editorControl and components like this is horrible, should
// be handled through Redux and a separate registry store for instances
let editorControl;
// eslint-disable-next-line func-style
let _getEditorComponents = () => Map();
export function getEditorControl() {
  return editorControl;
}
export function getEditorComponents() {
  return _getEditorComponents();
}
export default class MarkdownControl extends React.Component {
  constructor(props) {
    var _localStorage$getItem;
    super(props);
    _defineProperty(this, "handleMode", mode => {
      this.setState({
        mode,
        pendingFocus: true
      });
      localStorage.setItem(MODE_STORAGE_KEY, mode);
    });
    _defineProperty(this, "handleToggleFullscreen", () => {
      this.setState(prevState => ({
        isFullscreen: !prevState.isFullscreen
      }));
    });
    _defineProperty(this, "processRef", ref => this.ref = ref);
    _defineProperty(this, "setFocusReceived", () => {
      this.setState({
        pendingFocus: false
      });
    });
    _defineProperty(this, "getAllowedModes", () => this.props.field.get('modes', List(['rich_text', 'raw'])).toArray());
    editorControl = props.editorControl;
    const preferredMode = (_localStorage$getItem = localStorage.getItem(MODE_STORAGE_KEY)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : 'rich_text';
    _getEditorComponents = props.getEditorComponents;
    this.state = {
      mode: this.getAllowedModes().indexOf(preferredMode) !== -1 ? preferredMode : this.getAllowedModes()[0],
      pendingFocus: false,
      isFullscreen: false
    };
  }
  render() {
    const {
      onChange,
      onAddAsset,
      getAsset,
      value,
      classNameWrapper,
      field,
      getEditorComponents,
      getRemarkPlugins,
      resolveWidget,
      t,
      isDisabled
    } = this.props;
    const {
      mode,
      pendingFocus
    } = this.state;
    const isShowModeToggle = this.getAllowedModes().length > 1;
    const visualEditor = ___EmotionJSX("div", {
      className: "cms-editor-visual",
      ref: this.processRef
    }, ___EmotionJSX(VisualEditor, {
      onChange: onChange,
      onAddAsset: onAddAsset,
      isShowModeToggle: isShowModeToggle,
      onMode: this.handleMode,
      isFullscreen: this.state.isFullscreen,
      onToggleFullscreen: this.handleToggleFullscreen,
      getAsset: getAsset,
      className: classNameWrapper,
      value: value,
      field: field,
      getEditorComponents: getEditorComponents,
      getRemarkPlugins: getRemarkPlugins,
      resolveWidget: resolveWidget,
      pendingFocus: pendingFocus && this.setFocusReceived,
      t: t,
      isDisabled: isDisabled
    }));
    const rawEditor = ___EmotionJSX("div", {
      className: "cms-editor-raw",
      ref: this.processRef
    }, ___EmotionJSX(RawEditor, {
      onChange: onChange,
      onAddAsset: onAddAsset,
      isShowModeToggle: isShowModeToggle,
      onMode: this.handleMode,
      getAsset: getAsset,
      className: classNameWrapper,
      value: value,
      field: field,
      pendingFocus: pendingFocus && this.setFocusReceived,
      t: t
    }));
    return ___EmotionJSX(Fullscreen, {
      isFullscreen: this.state.isFullscreen
    }, mode === 'rich_text' ? visualEditor : rawEditor);
  }
}
_defineProperty(MarkdownControl, "propTypes", {
  onChange: PropTypes.func.isRequired,
  onAddAsset: PropTypes.func.isRequired,
  getAsset: PropTypes.func.isRequired,
  classNameWrapper: PropTypes.string.isRequired,
  editorControl: PropTypes.elementType.isRequired,
  value: PropTypes.string,
  field: ImmutablePropTypes.map.isRequired,
  getEditorComponents: PropTypes.func,
  t: PropTypes.func.isRequired
});
_defineProperty(MarkdownControl, "defaultProps", {
  value: ''
});